import React, { useState, useEffect } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import MarkdownRenderer from "./components/MarkdownRenderer";
import apiClient from "./utils/apiClient"; // Ensure correct import

const ReportTableBioInterpreter = ({ userId, reportId, filename = "biointerpreter_response.md" }) => {
  const [bioInterpreterMd, setBioInterpreterMd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFile = async () => {
      setLoading(true);
      setError(null);
      try {
        // Updated to use userId and reportId in the correct path
        const response = await apiClient.getRaw(`/report-path/${userId}/work/${reportId}/${filename}`);
        setBioInterpreterMd(response);
      } catch (err) {
        setError("Failed to load BioInterpreter report.");
        setBioInterpreterMd(null);
      } finally {
        setLoading(false);
      }
    };

    fetchFile();
  }, [userId, reportId, filename]);

  return (

      <Box sx={{ mt: 2, p: 2, border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : bioInterpreterMd ? (
          <MarkdownRenderer>{bioInterpreterMd}</MarkdownRenderer>
        ) : (
          <Typography>No content available.</Typography>
        )}
      </Box>

  );
};

export default ReportTableBioInterpreter;
